import { useState, useEffect } from 'react';
import { fetchBasicUserDataByUUID } from '../../../services/b2b-users-apiService';

const useFetchingBasicUserData = (userUUID, accessToken) => {
    const [userData, setUserData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchUserData = async (userUUID, accessToken) => {
        try {
            const fetchedUserData = await fetchBasicUserDataByUUID(userUUID, accessToken);
            setUserData(fetchedUserData);
        } catch (err) {
            console.error('Error fetching user data:', err);
            setError(err);
        }
    };

    useEffect(() => {
        if (userUUID && accessToken) {
            setLoading(true);
            fetchUserData(userUUID, accessToken).finally(() => setLoading(false));
        }
    }, [userUUID, accessToken]);

    return { userData, error, loading };
};

export default useFetchingBasicUserData;